import { gql } from '@apollo/client';
import { USER } from './user';

export const FILE = gql`
  fragment file on File {
    id
    url
    name
    uploadedBy {
      ...user
    }
  }
  ${USER}
`;
